import type Language from '@@/enums/Language'

export const useLanguage = () => {
  const { t, setLocale } = useI18n()
  const { user } = storeToRefs(useAuthStore())
  const { fetchCoreExternal } = useVgsFetch()
  const router = useRouter()
  const toast = useKlossToast()

  const updateLanguage = async (newLang: Language) => {
    if (!user.value) return

    user.value.preferredLanguage = newLang
    try {
      await fetchCoreExternal('/frontend/session/user', {
        method: 'PUT',
        body: JSON.stringify(user.value),
      })
    }
    catch (error) {
      console.error('Failed to update user language', error)
      toast.error(t('updateLanguage.failed'))
    }
    setLocale(newLang)
    router.go(0)
  }

  return {
    updateLanguage,
  }
}
